import { GetPrestamoByFiltersDtoProps } from "api/DTOs/GetPrestamoByFiltersDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"
import { EstadoPrestamo } from "../EstadoPrestamo"
import { CellTooltip } from "./CellTooltip"

export const TABLE_PRESTAMO_COLUMNS = (t: TFunction) => {
  const columns = [
    {
      key: "identificador",
      field: "identificador",
      header: t("prestamos.tab.headerId"),
      sortable: true,
      sortField: "identificador",
      className: "!tw-text-right",
      alignCol: "right",
      style: { width: "4%" },
    },
    {
      key: "numero",
      field: "numero",
      header: `${t("prestamos.tab.headerLedgerAccount")}`,
      sortable: false,
      className: "!tw-text-right",
      alignCol: "right",
    },
    {
      key: "fecha",
      field: "fecha",
      header: `${t("prestamos.tab.headerInitDate")}`,
      sortable: true,
      sortField: "fecha",
      className: "!tw-text-right",
      alignCol: "right",
      body: ({ fecha }: GetPrestamoByFiltersDtoProps) =>
        fecha ? frontendDateFormat(new Date(fecha)) : "",
    },
    {
      key: "razonSocial",
      field: "razonSocial",
      header: `${t("prestamos.tab.headerClient")}`,
      sortable: true,
      sortField: "Empresa.RazonSocial",
      style: { width: "14%" },
      className:
        "!tw-text-ellipsis !tw-overflow-hidden !tw-whitespace-nowrap !tw-flex-1 !tw-max-w-0 !tw-pl-6",
      body: ({ razonSocial, identificador }: GetPrestamoByFiltersDtoProps) => {
        return razonSocial
          ? CellTooltip({
              text: razonSocial,
              target: `tooltip-razonSocial-${identificador}`,
            })
          : "-"
      },
    },
    {
      key: "concepto",
      field: "concepto",
      header: `${t("prestamos.tab.headerConcept")}`,
      sortable: true,
      sortField: "concepto",
      style: { width: "14%" },
      className:
        "!tw-text-ellipsis !tw-overflow-hidden !tw-whitespace-nowrap !tw-flex-1 !tw-max-w-0 !tw-pl-6",
      body: ({ concepto, identificador }: GetPrestamoByFiltersDtoProps) => {
        return concepto
          ? CellTooltip({
              text: concepto,
              target: `tooltip-concepto-${identificador}`,
            })
          : "-"
      },
    },
    {
      key: "estado",
      field: "estado",
      header: `${t("prestamos.tab.headerState")}`,
      sortable: true,
      sortField: "estado",
      className: "!tw-text-right tw-font-medium",
      alignCol: "center",
      body: ({ estado, id }: GetPrestamoByFiltersDtoProps) =>
        EstadoPrestamo({ variant: estado, id, t }),
    },
    {
      key: "deuda",
      field: "deuda",
      header: `${t("prestamos.tab.headerDebit")}`,
      sortable: false,
      style: { width: "4%" },
      className: "!tw-text-right",
      alignCol: "right",
    },
    {
      key: "importeAmortizacion",
      field: "importeAmortizacion",
      header: `${t("prestamos.tab.headerImpAmortization")}`,
      sortable: true,
      sortField: "importeAmortizacion",
      style: { width: "6%" },
      className: "!tw-text-right",
      alignCol: "right",
      body: ({ importeAmortizacion }: GetPrestamoByFiltersDtoProps) =>
        typeof importeAmortizacion === "number"
          ? `${frontendCurrency(importeAmortizacion)}`
          : "-",
    },
    {
      key: "importe",
      field: "importe",
      header: `${t("prestamos.tab.headerTotalTax")}`,
      sortable: true,
      sortField: "importe",
      className: "!tw-text-right",
      alignCol: "right",
      body: ({ importe }: GetPrestamoByFiltersDtoProps) =>
        typeof importe === "number" ? `${frontendCurrency(importe)}` : "-",
    },
    {
      key: "totalAmortizado",
      field: "totalAmortizado",
      header: `${t("prestamos.tab.headerWritteOff")}`,
      sortable: false,
      className: "!tw-text-right",
      alignCol: "right",
      body: ({ totalAmortizado }: GetPrestamoByFiltersDtoProps) =>
        typeof totalAmortizado === "number"
          ? `${frontendCurrency(totalAmortizado)}`
          : "-",
    },
    {
      key: "importePendiente",
      field: "importePendiente",
      header: `${t("prestamos.tab.headerOutstandingCapital")}`,
      sortable: false,
      className: "!tw-text-right",
      alignCol: "right",
      body: ({ importePendiente }: GetPrestamoByFiltersDtoProps) =>
        typeof importePendiente === "number"
          ? `${frontendCurrency(importePendiente)}`
          : "-",
    },
  ]
  return columns
}
